import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { LiveSessionBar } from './LiveSessionBar';

export function DesktopLayout({ children, compact = false }: { children: ReactNode; compact?: boolean }) {
  return (
    <div className="desktop-shell">
      {/* Title-bar drag region. Only painted when Window Controls Overlay
          is active (installed PWA on desktop); collapses to 0px height in
          regular browser tabs. The OS min/max/close buttons float on top. */}
      <div className="desktop-titlebar" aria-hidden="true" />
      <LiveSessionBar />
      <Sidebar compact={compact} />
      <main className="desktop-main">{children}</main>
    </div>
  );
}
